import "./App.css";
import React, { useEffect, useState } from "react";

import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";
import ScrollupAndDownButton from "./components/scrollUpAnDown/ScrollupAndDown";
import FormLogic from "./components/FormLogic";
import { BASE_URL, BASE_URL_IMG, LOGIN } from "./api.config";
import { useTokenStore } from "./hooks/useTokenStore";
import { TbClock } from "react-icons/tb";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Form />
    </QueryClientProvider>
  );
}

const usePreloadImages = (imagePaths: any) => {
  useEffect(() => {
    imagePaths.forEach((path: any) => {
      const img = new Image();
      img.src = path;
    });
  }, [imagePaths]);
};

function Form() {
  const setTokenStore = useTokenStore((s) => s.setToken);
  const [startForm, setStartForm] = useState(false);
  const [goingUp, setGoingUp] = useState(false);

  const [images, setImages] = useState([]);
  const [transition, setTransition] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev < 100) {
          return prev + 0.5; // Smaller increments for smoother progress
        } else {
          clearInterval(timer); // Stop the timer when progress reaches 100%
          return prev;
        }
      });
    }, 25); // Reduce interval time for smoother progress update

    return () => clearInterval(timer); // Clear timer on component unmount
  }, []);

  // Show form after progress reaches 100% and add a slight delay for smoother transition
  useEffect(() => {
    if (progress === 100) {
      setTimeout(() => {
        setShowForm(true);
      }, 500); // Delay before showing form to ensure smooth progress completion
    }
  }, [progress]);
  const loginWithUsername = async () => {
    const userEmailData = new FormData();
    userEmailData.append("mode", "username");
    userEmailData.append("username", process.env.REACT_APP_USERNAME!);
    const data = await fetch(`${BASE_URL}${LOGIN}`, {
      method: "POST",
      headers: {
        "Accept-Language": "en-US,en;q=0.8",
      },
      body: userEmailData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "ok") {
          loginWithPassword(
            data.result.id,
            data.result.token,
            process.env.REACT_APP_PASSWORD!
          );
        }
      })
      .catch((err) => console.log(err));
    return data;
  };
  useEffect(() => {
    loginWithUsername();
  }, []);

  const loginWithPassword = async (
    id: string,
    token: string,
    password: string
  ) => {
    const userPassData = new FormData();
    userPassData.append("mode", "password");
    userPassData.append("id", id);
    userPassData.append("password", password);
    const data = await fetch(`${BASE_URL}${LOGIN}`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Accept-Language": "en-US,en;q=0.8",
      },
      body: userPassData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "ok") {
          setTokenStore(data.result.token);
          fetchImages(data.result.token);
        }
      })
      .catch((err) => console.log(err));

    return data;
  };

  const fetchImages = async (token: string) => {
    const response = await fetch(`${BASE_URL}img.paths`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setImages(data.result.imgPaths);
      })

      .catch((err) => {
        console.log(err);
      });
    return response;
  };

  usePreloadImages(
    images.map(
      (image: { img_path: string; id: string }) =>
        `${BASE_URL_IMG}${image.img_path}`
    )
  );
  const form = document.getElementById("form");

  const handleSubmit = () => {
    setStartForm(true);
  };
  useEffect(() => {
    setTimeout(() => {
      setTransition(true);
    }, 200);
  }, []);

  if (!startForm) {
    return (
      <div className="h-screen w-screen">
        <div className="bg-[url('../public/img/large.jpg')] h-full w-full">
          <div className="h-full w-full bg-black/85 flex flex-col items-center justify-center">
            {showForm && (
              <img
                src={require("./assets/piranha.png")}
                alt="piranha logo"
                className="absolute top-10 left-10 w-16 h-12 lg:top-24 lg:left-24  object-cover"
              />
            )}
            <div className="  no-scrollbar px-4 lg:px-0 min-h-[500px]   max-h-[700px] overflow-y-auto w-full  mx-4">
              <div
                className={`transition-transform ease-in-out duration-500 pt-10  ${
                  transition
                    ? "transform translate-y-0 "
                    : goingUp
                    ? "-translate-y-full"
                    : "translate-y-full"
                }  w-full h-full items-center justify-center`}
              >
                {showForm ? (
                  <form
                    id="form"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(); // Trigger the form submission on Enter
                      }
                    }}
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit(); // Also handle form submission on button click
                    }}
                    className="flex flex-col items-center justify-center space-y-4"
                  >
                    <h1 className="text-6xl text-center">
                      Instant Tray & Canopy
                    </h1>
                    <h1 className="text-6xl text-center">Quote Form</h1>
                    <div className="flex items-center space-x-2 relative">
                      <button
                        type="submit"
                        className="text-blueish w-24  py-2 mt-4"
                      >
                        Start
                      </button>
                      <p className="text-white absolute text-xs font-thin mt-3 -right-24">
                        press <span className="font-semibold">Enter ↵</span>
                      </p>
                    </div>
                    <div className="flex items-center space-x-1">
                      <TbClock className="h-4 w-4 fill-white" />

                      <p className="text-white">Takes 45 sec</p>
                    </div>
                  </form>
                ) : (
                  <div className="flex flex-col items-center justify-center">
                    <img
                      src={require("./assets/piranha.png")}
                      alt="piranha logo"
                      className="  w-16 h-12 lg:top-24 lg:left-24  object-cover mb-3"
                    />
                    <div className="w-60 h-1 bg-gray-700 rounded-lg overflow-hidden">
                      <div
                        style={{ width: `${progress}%` }}
                        className="h-full bg-white transition-all duration-300 ease-in-out"
                      ></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className=" h-screen w-screen ">
      <div className="bg-[url('../public/img/large.jpg')] h-full w-full">
        <div className="h-full w-full bg-black/85 flex flex-col items-center justify-center">
          <img
            src={require("./assets/piranha.png")}
            alt="piranha logo"
            className="absolute top-10 left-10 w-16 h-12 lg:top-24 lg:left-24  object-cover"
          />
          <FormLogic />
        </div>
      </div>
    </div>
  );
}
